import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
	canDeactivate(component: CanComponentDeactivate) {
		const componentCanDeactivate = component.canDeactivate;
		let returnValue = component.canDeactivate();

		if (componentCanDeactivate) {
			returnValue = returnValue;
		} else {
			returnValue = true;
		}

		return returnValue;
	}
}
